import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

if (window.innerWidth > 1200) {
  const helpCards = document.querySelector(".help_cards")
  const article = document.querySelector(".article")

  if (helpCards && article) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: helpCards,
        pin: true,
        start: "top 20px",
        endTrigger: article,
        end: "bottom bottom",
        scrub: 1,
      },
    })
  }
}